import { useEffect } from 'react';

/**
 * ONE AUDIO CONTEXT for the whole voice module: the capture's meter and the live ears' frames, and the mouth's sound.
 * (A context per press made three in one session on the iPhone app, each a thing iOS must unlock and a limit it counts.)
 * Stopping an ear never closes it; it is closed only when the last panel that uses voice unmounts (useSharedAudio).
 */
let shared = null;
let users = 0;
const Ctor = () => (typeof window !== 'undefined' ? window.AudioContext || window.webkitAudioContext : null);

/** The one context, made on first use (inside a tap, so iOS lets it run) and resumed whenever it is asked for. */
export function getAudioContext() {
  const Ctx = Ctor();
  if (!Ctx) return null;
  if (!shared || shared.state === 'closed') shared = new Ctx();
  if (shared.state === 'suspended') { try { shared.resume(); } catch (_) { /* gone */ } }
  return shared;
}

export function closeAudioContext() {
  const ctx = shared;
  shared = null;
  if (ctx && ctx.state !== 'closed') { try { ctx.close(); } catch (_) { /* gone */ } }
}

/** A panel that uses voice says so while it is mounted; the context goes when the last one is gone. */
export function useSharedAudio() {
  useEffect(() => {
    users += 1;
    return () => { users -= 1; if (users <= 0) { users = 0; closeAudioContext(); } };
  }, []);
}
